<p-input-otp class="otp" [(ngModel)]="value" [disabled]="disabled" [integerOnly]="true" (onChange)="onChange($event)" ></p-input-otp>

